import { useNavigateToDataPreparationPage } from "@/utils/redirects";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useDataPreparationDeepLink } from "./deep-link/data-preparation-deep-link";

/**
 * @returns Redirected entry point of the data preparation page (aka the staging area).
 * Redirects from /data-preparation/project/:projectId to /project/:projectId/draft
 */
export function DataPreparationPageRedirect(): null {
  useDataPreparationDeepLink();
  const { projectId } = useParams();
  const navigateToDataPreparationPage = useNavigateToDataPreparationPage();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (projectId) {
      navigateToDataPreparationPage({
        projectId,
        revisionId: searchParams.get("revisionId") ?? undefined,
      });
    }
  }, [navigateToDataPreparationPage, projectId, searchParams]);

  return null;
}
